var QueryStringHelper = QueryStringHelper || {};

QueryStringHelper.cleanParams = function(queryString, regexParams) {
    //const reducer = (result, regex) => result.replace(regex,'');
    return regexParams.reduce(function (result,regex) {
        return result.replace(regex,'');
    },queryString);
}

export { QueryStringHelper };



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/queryString.js